<template lang="pug">
  #ClientSearch
    form(@submit.prevent="toSearch" @keyup.enter="toSearch")
      .input-group
        input(v-if="type_app === 'pedrosa'" ref="search" id="product-search-query" class="form-control" type="search" v-model="q" minlength="2" :placeholder="placeholderPedrosa.search" @keyup="changeSearch" @search="toSearch()")
        input(v-else ref="search" id="product-search-query" class="form-control" type="search" v-model="q" minlength="2" :placeholder="placeholder.search" @keyup="changeSearch" @search="toSearch()")
        span.input-group-btn
          button.btn.btn-action(type="submit")
            img(:src="img.lupa" width="16" title="Search")
    span(class="hidden") #[translate xxx#/]
</template>
<script>
export default {
  name: 'OrderSearch',
  props: [],
  data () {
    return {
      q: null,
      placeholder: {
        'search': this.$gettext('Buscar pedido: Nombre Centro, Código de Producto, Nº de pedido...')
      },
      placeholderPedrosa: {
        'search': this.$gettext('Buscar pedido: Nombre Centro, Referencia, Nº de pedido...')
      },
      img: {
        lupa: require('@/assets/img/icos/buscar.svg')
      }
    }
  },
  methods: {
    changeSearch () {
      let ref = this
      clearTimeout(this.timerSearch)
      this.timerSearch = setTimeout(() => {
        // console.log('---busca')
        ref.toSearch()
      }, 1000)
    },
    toSearch () {
      let query = this.q

      if (query === null || query === '' || query.length > 2) {
        // console.log(`to search: ${query},  ${query.length}`)
        this.$emit('toSearch', [query])
      }
    }
  },
  computed: {
    type_app () {
      return this.$config.type
    }
  }
}
</script>
<style lang="scss" scoped>
  input[type="search"]{
    height:40px;
    line-height: 40px;
  }
  .btn{
    padding-top:0;
    padding-bottom:0;
    height:40px;
    line-height: 38px;
    img{
      max-width: none;
    }
  }
</style>
